 <app-table-title [fontSize]="'24px'" [title]="(differentLoggedIn ? label : ('MY' | dictionary)) + ' ' + ('FORMS' | dictionary)"></app-table-title>
 <div class="m-portlet m-portlet--unair">

     <div class="table-responsive">
       <div class="table-hover">
           <div *ngFor="let form of forms" class="item-row cursor-pointer" (click)="Download(form.seqNum,form.FileNum)">
             <i class="fas fa-file-alt icon"></i>
             <span class="text-color-black form-label">{{form.Label}}</span>
         </div>
       </div>
       <div class="grow-1"></div>
       <div class="col-lg-12 more-wrapper">
                         <span class="float-right">
                             <a [routerLink]="['/forms']">...{{'MORE' | dictionary}}</a></span>
       </div>
     </div>
 </div>

 <app-pop-up-dialog [Message]="alertMessage" [Display]="display" (DisplayBack)="onConfirm()">
 </app-pop-up-dialog>
